import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  timer: {
    maxWidth: 160,
  },
  timerText: {
    backgroundColor: 'transparent',
    color: '#FFF',
    fontWeight: '600',
    fontSize: 14,
  },
});
